import React, { useState, useEffect } from "react";
import StudentSidebar from "../../components/report/StudentSidebar";
import StudentGoalsList from "../../components/report/StudentGoalsList";
import { getRequest } from "../../apiWrapper";

const StudentGoalsPage = () => {
  const [studentid, setStudentId] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [teacherStudents, setTeacherStudents] = useState([]);
  const [studentColors, setStudentColors] = useState({});

  useEffect(() => {
    const role = sessionStorage.getItem("userRole");
    setIsAdmin(role === "admin");

    if (role !== "admin") {
      const fetchData = async () => {
        try {
          const [studentRes, settingsRes] = await Promise.all([
            getRequest("teacherStudents"),
            getRequest("settings/default")
          ]);

          if (studentRes?.students && settingsRes?.colors?.studentColors) {
            const colorMapping = settingsRes.colors.studentColors;

            // student.color は custom3 など → 対応する色コードに変換
            const studentsWithColor = studentRes.students.map((s) => ({
              ...s,
              resolvedColor: colorMapping[s.color] || "#ccc"
            }));

            setTeacherStudents(studentsWithColor);
            setStudentColors(colorMapping);
            setStudentId(studentsWithColor[0]?.studentid || null);
          }
        } catch (err) {
          console.error("❌ データ取得エラー:", err);
        }
      };
      fetchData();
    }
  }, []);

  if (isAdmin) {
    return (
      <div className="pt-10 flex h-screen">
        <div className="w-64 bg-white border-r overflow-y-auto">
          <StudentSidebar
            isAdmin
            selectedStudentId={studentid}
            onSelectStudent={(id) => setStudentId(id)}
          />
        </div>
        <div className="flex-1 overflow-y-auto p-6 bg-white">
          {studentid ? (
            <StudentGoalsList studentid={studentid} isAdmin />
          ) : (
            <p className="text-gray-500">生徒を選択してください</p>
          )}
        </div>
      </div>
    );
  }

  // 講師モード（タブUI）
  return (
    <div className="pt-10 flex flex-col min-h-screen">
      <div className="flex gap-2 px-4 py-2 border-b overflow-x-auto bg-white">
        {teacherStudents.map((student) => (
          <button
            key={student.studentid}
            className={`px-4 py-2 rounded-full font-semibold text-xs transition border ${studentid === student.studentid
                ? "border-2"
                : "border"
              }`}
            style={{
              backgroundColor: "#fff",
              borderColor: studentid === student.studentid ? student.resolvedColor : "#d1d5db", // #d1d5db は tailwind の gray-300
              color: studentid === student.studentid ? "#000" : "#4b5563", // gray-700
              textShadow: `1px 1px 4px ${student.resolvedColor}`
            }}
            onClick={() => setStudentId(student.studentid)}
          >
            {student.name}
          </button>

        ))}
      </div>

      <div className="flex-1 overflow-y-auto p-4 bg-white">
        {studentid ? (
          <StudentGoalsList studentid={studentid} />
        ) : (
          <p className="text-gray-500">生徒を選択してください</p>
        )}
      </div>
    </div>
  );
};

export default StudentGoalsPage;
